module.exports = __webpack_public_path__ + "img/5.d39cf0f6.jpg";